import styled from 'styled-components';

export const TableControls = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 1em;

    .pagination {
        display: flex;
        align-items: center;
        color: #fff;
        width: 100%;

        transition: visibility 300ms ease;

       .page-btn {
            padding: .5em 1em;
        }

        select {width: 120px;}
    }

    .pagination > * {margin: .5em;}
`


// WEBPACK FOOTER //
// ./src/components/Admin/PaginationTable/PaginationTable.styles.tsx